module.exports = __webpack_public_path__ + "fonts/CormorantUpright-Regular.a7d5877.ttf";